import { lazy } from 'react'
export const StartupProtectedRoute = lazy(() => import('../routes/StartupProtectedRoute'))
export const LearnInvestProtectedRoute = lazy(() => import('../routes/learnInvestProtectedRoute'))
export const Series65ProtectedRoute = lazy(() => import('../routes/series65ProtectedRoute'))
export const InvestorProtectedRoute = lazy(() =>
  import('../components/ProtectedRoutes/InvestorProtectedRoute'),
)
export const ScoutProtectedRoute = lazy(() => import('../routes/scoutProtectedRoute'))
export const RecruitProtectedRoute = lazy(() => import('../routes/recruitProtectedRoute'))
